import React from 'react';
type CtaButtonSize = 'md' | 'lg';
type CtaButtonProps = {
  label?: string;
  size?: CtaButtonSize;
  className?: string;
  pulse?: boolean;
  href?: string;
};
const sizeStyles: Record<CtaButtonSize, string> = {
  md: 'px-6 py-4 text-[15px]',
  lg: 'px-6 py-5 text-base sm:text-lg'
};

/**
 * Primary conversion button. Every instance scrolls the visitor to the
 * pricing card, which acts as the (simulated) checkout.
 */
export function CtaButton({
  label = 'ACCEDER A PRECIO ESPECIAL →',
  size = 'lg',
  className = '',
  pulse = false,
  href = '#precio'
}: CtaButtonProps) {
  return <a href={href} className={['group inline-flex w-full items-center justify-center rounded-2xl bg-flame text-center font-extrabold uppercase tracking-[0.02em] text-white', 'shadow-[0_10px_0_0_#a52d05] transition-all duration-150', 'hover:bg-flame-dark hover:shadow-[0_6px_0_0_#a52d05] hover:translate-y-[4px]', 'active:translate-y-[8px] active:shadow-[0_2px_0_0_#a52d05]', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-night', sizeStyles[size], pulse ? 'cta-pulse' : '', className].join(' ')} data-id="element-251" data-mp="1d4zm87myq7ba">
      <span className="leading-tight" data-id="element-252" data-mp="2chgnv7wq0pso">{label}</span>
    </a>;
}